import { Roll } from '@/types/Roll';
import { JDR } from '@/types/Interfaces';

export class DamageRoll extends Roll {

    constructor(stat: string, playerName: string) {
        super(stat, JDR.ParceDomine, playerName);
    }

    roll(char: null, secret: boolean): void {
        let min = 0;
        let max = 0;
        switch (this.stat) {
            case 'physique':
                min = 15;
                max = 25;
                break;
            case 'blanche':
                min = 20;
                max = 30;
                break;
            case 'feu':
                min = 40;
                max = 50;
                break;
            case 'lueur pure':
                min = 35;
                max = 65;
                break;
            case 'env':
                min = 15;
                max = 25;
                break;
            case 'massif':
                min = 50;
                max = 70;
                break;
            case 'surpuissant':
                min = 70;
                max = 100;
                break;
        }
        //picks a random number between 1 and 20
        this.rolled = Math.floor(Math.random() * (max - min + 1) + min)
        this.statValue = max;

        this.secret = secret;

        //Modifies passed and critic fields according to roll
        this.passed = true;
        this.critic = (this.rolled && (this.rolled == max)) as boolean;
        this.setText();
        this.setCSSClass();
    }
}
